/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21 3c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3c0-1.6568 1.3431-3 3-3s3 1.3432 3 3Zm-1.5 0c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5ZM9 10.5c2.4853 0 4.5-2.0147 4.5-4.5S11.4853 1.5 9 1.5 4.5 3.5147 4.5 6s2.0147 4.5 4.5 4.5ZM9 9c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M14.8192 9.7883c.8288-.966 1.9571-1.5383 3.1804-1.5383 2.1902 0 4.1389 1.8852 4.4555 4.5h-4.4555a.75.75 0 0 0 0 1.5H24v-.75c0-3.6308-2.5956-6.75-6.0004-6.75-1.7143 0-3.2418.8061-4.3188 2.0617a.75.75 0 1 0 1.1384.9766Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.9089 21c.06.4897.0911.9902.0911 1.4992L0 22.5c0-.509.0311-1.0103.0911-1.5C.7151 15.9116 4.466 12 9 12c4.534 0 8.285 3.9116 8.9089 9ZM1.6018 21c.608-4.4118 3.8541-7.5 7.3982-7.5 3.5441 0 6.7902 3.0882 7.3982 7.5H1.6018Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuUsers'
);
